// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-e0346324] video{height:80vh;max-height:25rem;max-width:100%;width:auto}@media(min-width: 768px){[data-v-e0346324] video{max-height:35.5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
